import React from "react";
import { GridCellProps } from "@progress/kendo-react-grid";
import type { TrustCallPhone } from "../types";

interface FtcCountCellProps extends GridCellProps {
  onDetailsClick?: (phone: TrustCallPhone) => void;
}

const FtcCountCell: React.FC<FtcCountCellProps> = (props) => {
  const dataItem = props.dataItem as TrustCallPhone;
  const count = dataItem.ftcCount ?? 0;

  return (
    <td>
      <span style={{ fontWeight: "bold" }}>{count}</span>
      {count > 0 && props.onDetailsClick && (
        <>
          {" "}
          <button
            className="btn btn-dark btn-sm"
            style={{ fontSize: "0.7rem", padding: "2px 8px" }}
            onClick={() => props.onDetailsClick!(dataItem)}
          >
            Details
          </button>
        </>
      )}
    </td>
  );
};

export default FtcCountCell;
